import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';

import Flex from 'shopper/components/Flex';
import Tag from 'shopper/components/Tag';
import Text from 'shopper/components/Text';

const TAG_TYPE_UNIQUE = 'UNIQUE';

const OfferTags = ({ offerTitle, offerTags }) => {
  const theme = useTheme();

  return (
    <Flex alignItems="center" flexWrap="wrap" mt={offerTitle ? 2 : null}>
      {offerTags.map(({ name, type }) => {
        if (type === TAG_TYPE_UNIQUE) {
          return (
            <Text
              size="size2"
              key={name}
              color={theme.app.tag.uniqueForeground}
              mt={offerTitle ? 2 : null}
              mr={2}
            >
              {name}
            </Text>
          );
        }

        return (
          <Tag key={name} mt={offerTitle ? 2 : null} mr={2}>
            {name}
          </Tag>
        );
      })}
    </Flex>
  );
};

OfferTags.propTypes = {
  offerTags: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
  offerTitle: PropTypes.string.isRequired,
};

export default OfferTags;
